<div class="container-fluid">
  <h1 class="page-header">Projections Report</h1>

  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        Filter
      </mat-panel-title>
      <mat-panel-description>
        <app-filter-results-panel [parameters]=queryParams></app-filter-results-panel>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <form (ngSubmit)="onSubmit(f)" #f=ngForm class="form">
      <div class="row">

        <!-- Date Range Filter -->
        <div class="col-12 col-sm-6 col-lg">
          <mat-form-field>
            <mat-label>Enter a date range</mat-label>
            <mat-date-range-input [rangePicker]="picker">
              <input name="start_date" (dateChange)="onSubmit(f)" ngModel matStartDate placeholder="Start date">
              <input name="end_date" (dateChange)="onSubmit(f)" ngModel matEndDate placeholder="End date">
            </mat-date-range-input>
            <!-- <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint> -->
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
        </div>

        <!-- Student Autocomplete -->
        <div class="col-12 col-sm-6 col-lg">
          <mat-form-field class="full-width-field">
            <mat-label>Student</mat-label>
            <input #studentInput name="student_name" (input)="onAutocompleteStudent($event)" matInput ngModel
              [matAutocomplete]="autoCompleteStudent">
            <button (click)="redirectUserProfile(studentInput)" type="button" matSuffix mat-icon-button aria-label="manage_accounts">
              <mat-icon>manage_accounts</mat-icon>
            </button>
          </mat-form-field>
          <mat-autocomplete #autoCompleteStudent="matAutocomplete" (optionSelected)="onSubmit(f)">
            <mat-option *ngFor="let option of autoCompleteStudentOptions" [value]="option.label + ' ' + '(' + option.value + ')'">
              {{option.label}} ({{option.value}})
            </mat-option>
          </mat-autocomplete>
        </div>

        <!-- Enrollment Autocomplete -->
        <div class="col-12 col-sm-6 col-lg">
          <mat-form-field class="full-width-field">
            <mat-label>Enrollment</mat-label>
            <input name="enrollment_title" (input)="onEnrollmentAutocomplete($event)" matInput ngModel
              [matAutocomplete]="autoCompleteEnrollment">
            <button type="button" matSuffix mat-icon-button aria-label="manage_accounts">
              <mat-icon>manage_accounts</mat-icon>
            </button>
          </mat-form-field>
          <mat-autocomplete #autoCompleteEnrollment="matAutocomplete" (optionSelected)="onSubmit(f)">
            <mat-option *ngFor="let option of autoCompleteEnrollmentOptions" [value]="option.label + ' ' + '(' + option.value + ')'">
              {{option.label}} ({{option.value}})
            </mat-option>
          </mat-autocomplete>
        </div>

        <div class="col-12 col-sm-6 col-lg">
          <mat-form-field class="full-width-field">
            <mat-label>Status</mat-label>
            <mat-select matInput ngModel name="status" (blur)="onSubmit(f)" (selectionChange)="onSubmit(f)">
              <mat-option value="" selected="selected">- Any -</mat-option>
              <mat-option value="1">Paid</mat-option>
              <mat-option value="2">Not Paid</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <section class="section">

          <div class="float-end bring-inline">
            <button (click)="resetForm()" color="primary" mat-flat-button class="me-1" mat-button>Clear
              <!-- <mat-icon (click)="resetForm()" aria-hidden="false" aria-label="Menu dropdown" class=""></mat-icon> -->
            </button>
          </div>

        </section>
      </div>


      <section class="section">
      </section>

    </form>

  </mat-expansion-panel>

  <mat-progress-bar [class.invisible]="!ShowProgressBar" mode="indeterminate"></mat-progress-bar>
  <div class="row">
    <div class="col-md-12 mt-3">
      <div class="float-end">
        <!-- <button (click)="onPrint()" color="primary" mat-flat-button class="me-1" mat-button>Print</button> -->
        <!-- <button (click)="onDownloadCSV()" color="primary" mat-flat-button class="me-1 warning" mat-button>CSV</button> -->
      </div>
    </div>
  </div>

  <div class="table-responsive-sticky table-responsive">

    <table mat-table #displayTable [dataSource]="dataSource" matSort (matSortChange)="sortData($event)" class="mt-4">

      <!-- date Column -->
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by Date">
          Date
        </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element[0].data">{{ element[0].data }}</ng-container>
        </td>
      </ng-container>

      <!-- Students Column -->
      <ng-container matColumnDef="students">
        <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by Students">
          Students
        </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element[1].data">{{ element[1].data }}</ng-container>
        </td>
      </ng-container>

      <!-- Enrollments Column -->
      <ng-container matColumnDef="enrollments">
        <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by Enrollments">
          Enrollments
        </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element[2].data">{{ element[2].data }}</ng-container>
        </td>
      </ng-container>

      <!-- Expected Amount Column -->
      <ng-container matColumnDef="expected_amount">
        <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by Expected Amount">
          Expected Amount
        </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element[3].data">{{ element[3].data }}</ng-container>
        </td>
      </ng-container>

      <!-- Status Column -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by Status">
          Status
        </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element[4].data">{{ [element[4].data] }}</ng-container>
        </td>
      </ng-container>

      <!-- Footer for pagination -->
      <ng-container matColumnDef="pagination-footer">
        <td mat-footer-cell *matFooterCellDef [attr.colspan]="displayedColumns.length">
          <mat-paginator (page)="pageChanged($event)" [pageSizeOptions]="onPageSizeOptions()" [length]="10"
            [disabled]="ShowProgressBar"
            [pageSize]="paginationTotalPages" [pageIndex]="paginationIndex" aria-label="Select page of view"></mat-paginator>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row matRipple *matRowDef="let row; columns: displayedColumns;"></tr>
      <tr mat-footer-row *matFooterRowDef="['pagination-footer']; sticky: true"></tr>
    </table>

  </div>
</div>
